import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import {Link, withRouter} from 'react-router';

import Button from '../Button';

import {withUser} from '../SessionSplit';
import withI18n from 'spa/Components/Context/withI18n';

@withRouter
@observer
@withUser
@withI18n
class Referral extends React.Component {
  static propTypes = {
    user: PropTypes.shape({
      name: PropTypes.string,
      email: PropTypes.string.isRequired,
    }).isRequired,
  };

  render() {
    const {i18n} = this.context;

    return (
      <div className="site-header--show-desktop site-header-col site-header-col--referral">
        <Link
          className="site-header__referral-button"
          to={`/${i18n.lc}/account/refer`}
        >
          {i18n._x('Free Treatments', 'Referral header button label')}
        </Link>
      </div>
    );
  }
}

export default Referral;



// WEBPACK FOOTER //
// ./spa/Components/Header/Referral.jsx